// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"32ea8dac","732":"ffeb6b25","977":"80f35ea5"}[chunkId] + ".chunk.js";
};